export default "__VITE_ASSET__DXMlY$yA__"